<!-- <div style="margin-left:1%;margin-top: 5px; margin-bottom: 5px;" class="admin-block d-flex">
    <div style="background:white; border-radius: 20px 0px 0px 20px;">
        <img [src]="portal_main.Info2ImageUrl" class="img-circle" width="50px" style="max-width: 75%;padding-left: 3px;padding-top: 2px" />
    </div>
    <div class="admin-info" style="background: white; border-radius: 0px 10px 10px 0px;width:170px ;overflow-y: hidden;">
        <div class="font-strong" style="padding-right: 20px;"> {{portal_main.info2['name']}}</div>
        <small>{{portal_main.info2['designation_cd']}}</small>
    </div>
</div> -->
<!-- 
<div style=" margin-left: 28px; margin-top: 5px; margin-bottom: 5px;" class="admin-block d-flex">
    <div style="background:white; border-radius: 20px 0px 0px 20px;">
        <img [src]="portal_main.Info1ImageUrl" class="img-circle" width="50px" style="max-width: 75%;padding-left: 3px;padding-top: 2px" />
    </div>
    <div class="admin-info" style="background:white; border-radius: 0px 10px 10px 0px; width:170px ;overflow-y: hidden;">
        <div class="font-strong" style="padding-right: 20px;"> {{portal_main.info1['name']}}</div>
        <small>{{portal_main.info1['designation_cd']}}</small>
    </div>
</div> -->

<div style="margin-left:2%; margin-top: 5px; margin-bottom: 5px;" class="admin-block d-flex align-items-center">
    <i class="mobile-menu-btn d-sm-none text-white mr-3" [class.fa-bars]="!portal_main.isMobileSidebarOpen"
        [class.fa-times]="portal_main.isMobileSidebarOpen" class="fa"
        (click)="portal_main.isMobileSidebarOpen = !portal_main.isMobileSidebarOpen"
        style="font-size:24px; cursor:pointer; margin-right:15px;color: white !important;">
    </i>
    <!-- <i class="fa fa-bars mobile-menu-btn d-sm-none text-white mr-3"
        (click)="portal_main.isMobileSidebarOpen = !portal_main.isMobileSidebarOpen"
        style="font-size: 24px; cursor: pointer; margin-right: 15px;"></i> -->
    <div class="admin-info d-flex justify-content-center align-items-center"
        style="color: white;  border-radius: 0px 10px 10px 0px;width:fit-content;">
        <!-- <div class="font-strong" style="text-align: center;color: white;">{{portal_main.accInfo['account_name']}}</div> -->
        <div class="font-strong" style="text-align: center;color: white;     line-height: 42px;
    font-size: 22px;cursor: pointer" (click)="back()"><i
                class="fa fa-angle-left m-l-5 font-weight-bold text-white mr-3"></i>
            <!-- {{ss.headerMess}} -->

        </div>


        <!-- <div style="text-align: center;"> Online Management System </div> -->
    </div>
    <!-- <div class="d-flex justify-content-center align-items-center ms-5 mx-2"> -->
    <!-- <mat-form-field style="background-color: white;"> -->
    <!-- <mat-label>Search</mat-label> -->
    <!-- <input (keyup)="mainService.applyFilter($event)" placeholder="Type to search" class="search-bar"> -->
    <!-- </mat-form-field> -->

    <!-- </div> -->
</div>

<div class="flexbox flex-1">

    <div class="flexbox flex-1 party " >
        <h3 class="text-white w-100 d-block d-md-inline text-center">
            <!-- <span class="fw-500"><strong>{{portal_main.accInfo['account_name']}} </strong></span><br><span class="nagar-nigam-text">{{portal_main.accInfo['address']}}</span> -->
            <ng-container>
                <span class="fw-500"><strong> {{ translation.t('header', 'title') }} </strong></span><br><span
                    class="nagar-nigam-text">{{ translation.t('header', 'subtitle') }}</span>
            </ng-container>
            <!-- (लखनऊ नगर निगम) -->
        </h3>
    </div>

    <!-- START TOP-LEFT TOOLBAR-->
    <ul class="nav navbar-toolbar">
    </ul>
    <!-- END TOP-LEFT TOOLBAR-->

    <!-- START TOP-RIGHT TOOLBAR-->
    <ul class="nav navbar-toolbar">
        <!-- <li style="color: white; margin-right: 10px;">
            -:
        </li> -->
        <!-- <li class="nav-item" style="min-width: 180px;">
            <ng-select [multiple]="false" [placeholder]="translation.t('header','selectLanguage')" [items]="auth.allLanguage"
                bindLabel="language_desc" bindValue="language_cd" [selectableGroup]="true"
                [selectableGroupAsModel]="false" aria-placeholder="Select Language Code" [closeOnSelect]="true"
                name="language_cd" [(ngModel)]="auth.language_cd" (change)="changeLanguage()" style="width:150px;">
            </ng-select>
        </li> -->
        <!-- Logo: only below 576px -->
<div class="d-block d-xl-none ms-3">
  <img [src]="portal_main.accountImageUrl" class="logo_nav" style="border-radius: 10px;" />
</div>

<!-- Language toggle: only 576px and above -->
<div class="language-toggle ms-3 d-none d-xl-flex" (click)="toggleLanguage()" style="cursor: pointer;">
  <div class="toggle-circle"
    [ngClass]="{'hin-active': auth.language_cd === 'HIN', 'eng-active': auth.language_cd === 'ENG'}">
    {{ auth.language_cd === 'HIN' ? 'हिन्दी' : 'Eng' }}
  </div>
</div>
        <!-- <div class="language-toggle ms-3" (click)="toggleLanguage()" style="cursor: pointer;">
            <div class="toggle-circle"
                [ngClass]="{'hin-active': auth.language_cd === 'HIN', 'eng-active': auth.language_cd === 'ENG'}">
                {{ auth.language_cd === 'HIN' ? 'हिन्दी' : 'Eng' }}
            </div>
        </div> -->
        <!-- <div class="nav-item ms-3" style="min-width: 30px; ">   
        <ng-select 
            [multiple]="false" 
            [placeholder]="translation.t('header','selectLanguage')" 
            [items]="auth.allLanguage"
            bindLabel="language_desc" 
            bindValue="language_cd" 
            [selectableGroup]="true"
            [selectableGroupAsModel]="false" 
            aria-placeholder="Select Language Code" 
            [closeOnSelect]="true"
            name="language_cd" 
            [(ngModel)]="auth.language_cd" 
            (change)="changeLanguage()" 
            style="width:90px; min-width:90px;">
        </ng-select>
    </div> -->
        <li class="dropdown dropdown-inbox" [routerLink]="['/sdp/task']" routerLinkActive="router-link-active"
            *ngIf="checkNoti()">
            <a class="nav-link dropdown-toggle" data-toggle="dropdown">
                <span class="icons_header">
                    <i class="fa fa-bell"></i>
                    <sup class="font-weight-bold sup_icons">{{message_count}}</sup>
                </span>


            </a>
            <!-- <ul class="dropdown-menu dropdown-menu-right dropdown-menu-media">
                <li class="dropdown-menu-header">
                    <div>
                        <span><strong>{{mainService.count}} New</strong> {{mainService.allLableShowObj[mainService.language_cd+'AC_Header6']}}Messages</span>
                        <a class="pull-right" [routerLink]="['/task']">{{mainService.allLableShowObj[mainService.language_cd+'AC_Header7']}}view all</a>
                    </div>
                </li>
            </ul> -->
        </li>
        <!-- <li class="dropdown dropdown-notification">
            <a class="nav-link dropdown-toggle" data-toggle="dropdown"><i class="fa fa-bell-o rel"><span
                        class="notify-signal"></span></i></a>
            <ul class="dropdown-menu dropdown-menu-right dropdown-menu-media">
                <li class="dropdown-menu-header">
                    <div>
                        <span><strong>{{mainService.allLableShowObj[mainService.language_cd+'AC_Header5']}}</strong> {{mainService.allLableShowObj[mainService.language_cd+'AC_Header8']}}</span>
                        <a class="pull-right" href="javascript:;">{{mainService.allLableShowObj[mainService.language_cd+'AC_Header7']}}</a>
                    </div>
                </li>

            </ul>
        </li> -->
        <li class="line_ver"> </li>
        <li class="dropdown dropdown-user">
            <div class="nav-item full-screen">
                <a class="nav-link dropdown-toggle link nav-item text-center" data-toggle="dropdown">
                    <img [src]="portal_main.profileImageUrl" style="border-radius: 8px;" width="35px" height="35px" />
                    <span class=" r-font-s font-weight-bold text-white ml-2" *ngIf="erpUser">
                        <!-- {{erpUser['designation']}} -->
                        {{erpUser['party_name']}}</span>
                 <span class="r-font-s text-white ml-2" *ngIf="erpUser">( {{erpUser['role_cd']}} )</span><i class="fa fa-angle-down m-l-5 font-weight-bold text-white"></i></a>
                <div class="dropdown-menu dropdown-menu-right ">
                    <a class="dropdown-item " [routerLink]="['/sdp/UserProfileComponent']"
                        routerLinkActive="router-link-active"><i class="fa fa-user"></i> <span class="ms-3">{{
                        translation.t('header','profile') }} </span></a>
                    <!-- <a class="dropdown-item" *ngIf="erpUser?.role_cd?.includes('Admin')"   [routerLink]="['/portal/acc']"
                        routerLinkActive="router-link-active"><i class="fa fa-user-plus"></i>Portal Profile</a> -->
                    <a class="dropdown-item" (click)="logOut()" routerLinkActive="router-link-active"><i
                            class="fa fa-power-off"></i> <span class="ms-3">{{ translation.t('header','logout') }}</span></a>
                    </div>
            </div>
        </li>

        <!-- <li>
            <i class="fa fa-bars" style="font-size: 30px; color: #fff; margin-left: 10px; margin-right: 20px;"></i>
        </li> -->
    </ul>
    <!-- END TOP-RIGHT TOOLBAR-->
</div>